import CitySEOHead from "@/components/feature/CitySEOHead";
import KnoxvilleHeroSection from "./components/HeroSection";
import KnoxvilleStickyNav from "./components/StickyNav";
import KnoxvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import KnoxvilleFAQSection, { faqs } from "./components/FAQSection";
import CityServicesSection from "@/pages/city-template/components/CityServicesSection";
import CityLocalAreaSection from "@/pages/city-template/components/CityLocalAreaSection";
import CityTravelTimingSection from "@/pages/city-template/components/CityTravelTimingSection";
import CityDestinationsSection from "@/pages/city-template/components/CityDestinationsSection";
import CityTestimonialsSection from "@/pages/city-template/components/CityTestimonialsSection";
import CityAcceptanceFacilitiesSection from "@/pages/city-template/components/CityAcceptanceFacilitiesSection";
import CityComparisonSection from "@/pages/city-template/components/CityComparisonSection";
import CityMistakesSection from "@/pages/city-template/components/CityMistakesSection";
import CityHowItWorksSection from "@/pages/city-template/components/CityHowItWorksSection";
import CityHelpfulResourcesSection from "@/pages/city-template/components/CityHelpfulResourcesSection";
import CityFinalCTA from "@/pages/city-template/components/CityFinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import { knoxvilleConfig } from "./data";

export default function KnoxvillePage() {
  const c = knoxvilleConfig;
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Knoxville"
        state="Tennessee"
        stateAbbr="TN"
        route="/knoxville"
        title="Emergency Passport Knoxville, TN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Knoxville, TN — as fast as 24 hours. A+ BBB rated registered courier serving UT Knoxville, Oak Ridge, Smoky Mountains, and all East Tennessee. No Nashville drive required."
        geoPlacename="Knoxville, Tennessee"
        geoPosition="35.9606;-83.9207"
        faqs={faqs}
        servicesSchema={c.servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <KnoxvilleHeroSection />
      <KnoxvilleStickyNav />
      <KnoxvilleProcessingTimeSection />
      <CityServicesSection city={c.city} services={c.services} intro={c.servicesIntro} />
      <CityLocalAreaSection city={c.city} state={c.state} cities={c.nearbyCitiesZips} benefits={c.benefits} internalLinks={c.internalLinks} officeNote={c.fpcOfficeNote} officeDistance={c.fpcOfficeDistance} officeAddress={c.fpcOfficeAddress} serviceAreaIntro={c.serviceAreaIntro} nearbyCitiesIntro={c.nearbyCitiesIntro} />
      {c.travelTiming && <CityTravelTimingSection city={c.city} data={c.travelTiming} />}
      {c.destinations && <CityDestinationsSection city={c.city} data={c.destinations} />}
      <CityTestimonialsSection city={c.city} testimonials={c.testimonials} intro={c.testimonialsIntro} />
      <CityAcceptanceFacilitiesSection city={c.city} facilities={c.facilities} />
      <CityComparisonSection city={c.city} regionalAgency={c.regionalAgency} rows={c.comparisonRows} />
      <CityMistakesSection city={c.city} mistakes={c.mistakes} intro={c.mistakesIntro} />
      <CityHowItWorksSection city={c.city} steps={c.steps} intro={c.howItWorksIntro} />
      <KnoxvilleFAQSection />
      <CityHelpfulResourcesSection city={c.city} state={c.state} photoLocations={c.photoLocations} dmvLocations={c.dmvLocations} airports={c.airports} dmvWebsite={c.dmvWebsite} dmvLabel={c.dmvLabel} vitalRecordsLinks={c.vitalRecordsLinks} />
      <SEOCrossLinks currentRoute="/cities/knoxville" state="TN" />
      <CityFinalCTA />
    </div>
  );
}